import { useEffect } from "react";
import { motion } from "framer-motion";
import "./css/ProjectModal.css";

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="m5 13 4 4L19 7"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function ProjectModal({ project, onClose }) {
  const cs = project.caseStudy;

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <motion.div
      className="pm-backdrop"
      onClick={onClose}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <motion.div
        className="pm"
        role="dialog"
        aria-modal="true"
        aria-label={project.title}
        onClick={(e) => e.stopPropagation()}
        initial={{ opacity: 0, y: 24, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 24, scale: 0.98 }}
        transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
      >
        <button className="pm__close" onClick={onClose} aria-label="Close">
          ✕
        </button>

        <div className="pm__hero">
          <img src={project.img} alt={project.title} />
          {project.category && (
            <span className="pm__category">{project.category}</span>
          )}
        </div>

        <div className="pm__body">
          <h2 className="pm__title">{project.title}</h2>

          <div className="pm__meta">
            {cs.client && (
              <div>
                <span className="pm__meta-label">Client</span>
                {cs.client}
              </div>
            )}
            {cs.role && (
              <div>
                <span className="pm__meta-label">Role</span>
                {cs.role}
              </div>
            )}
            {cs.duration && (
              <div>
                <span className="pm__meta-label">Duration</span>
                {cs.duration}
              </div>
            )}
          </div>

          <div className="pm__tags">
            {project.tags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          <section className="pm__section">
            <h3>The challenge</h3>
            <p>{cs.challenge}</p>
          </section>

          <section className="pm__section">
            <h3>The solution</h3>
            <p>{cs.solution}</p>
          </section>

          <section className="pm__section">
            <h3>Roadblocks &amp; how I solved them</h3>
            <ul className="pm__list">
              {cs.roadblocks.map((item) => (
                <li key={item}>
                  <span className="pm__check">
                    <CheckIcon />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section className="pm__section pm__outcome">
            <h3>Outcome</h3>
            <p>{cs.outcome}</p>
          </section>
        </div>
      </motion.div>
    </motion.div>
  );
}
